import React, { Fragment } from "react";
import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../../../AbstractElements";

import LeftDetails from "./left-details";

const ProgramDetails = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle="Services" parent="Apps" title="services" />
      <Container fluid={true}>
        <div className="email-wrap bookmark-wrap">
          <Row>
            <LeftDetails />
          </Row>
        </div>
      </Container>
    </Fragment>
  );
};
export default ProgramDetails;
